module.exports = __webpack_public_path__ + "img/left-wide.06244c1a.png";